import * as qs from 'utils/qs'

export const urlToSearchState = router => {
    const {
        brands,
        hasDiscount,
        freeShipping,
        category,
        query,
        all_features,
        all_tags,
        to,
        sort,
        price_from,
        price_to,
        page = 1
    } = qs.parse(router.asPath.split('?')[1])
    const state = { toggle: {} }
    state.refinementList = {}
    state.page = page

    if (brands) {
        state.refinementList.brand_name = brands.split(',')
    }
    if (all_features) {
        state.refinementList.all_features = all_features.split(',')
    }
    if (all_tags) {
        state.refinementList.all_tags = all_tags.split(',')
    }
    if (to) {
        state.refinementList.all_audiences = to.split(',')
    }
    if (sort) {
        state.sortBy = sort
    }
    if (hasDiscount) {
        state.toggle.has_discount = 1
    }
    if (freeShipping) {
        state.toggle.has_free_shipping = 1
    }
    if (category && typeof 'category' === 'string') {
        state.hierarchicalMenu = {
            'hierarchical_taxonomies.lvl0': category.split('-').join(' > ')
        }
    }
    if (price_from || price_to) {
        state.range = {
            price_from: {
                min: price_from,
                max: price_to
            }
        }
    }
    if (query) {
        if (!state.configure) {
            state.configure = {}
        }
        state.configure.query = query
    }

    return state
}

export const createURL = state => {
    const { toggle, sortBy, hierarchicalMenu, refinementList, configure, page } = state

    const object = {}

    if (page) {
        object.page = page
    }
    if (sortBy) {
        object.sort = sortBy
    }
    if (configure && configure.query) {
        object.query = configure.query
    }
    if (toggle && toggle.has_discount) {
        object.hasDiscount = 1
    }
    if (toggle && toggle.has_free_shipping) {
        object.freeShipping = 1
    }
    if (refinementList && refinementList.brand_name) {
        object.brands = refinementList.brand_name.join(',')
    }
    if (refinementList && refinementList.all_features) {
        object.all_features = refinementList.all_features.join(',')
    }
    if (refinementList && refinementList.all_tags) {
        object.all_tags = refinementList.all_tags.join(',')
    }
    if (refinementList && refinementList.all_audiences) {
        object.to = refinementList.all_audiences.join(',')
    }
    if (hierarchicalMenu && hierarchicalMenu['hierarchical_taxonomies.lvl0']) {
        object.category = hierarchicalMenu['hierarchical_taxonomies.lvl0'].split(' > ').join('-')
    }
    if (state?.range?.price_from?.min) {
        object.price_from = state.range.price_from.min
    }
    if (state?.range?.price_from?.max) {
        object.price_to = state.range.price_from.max
    }
    const base = window.location.pathname
    const query = qs.stringify(object).replace('%EF%BB%BF', '').split('%20').join('+')
    return `${base}${query ? '?' : ''}${query}`
}
